import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import axios from 'axios'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

// Font Awesome
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas, faTrash, faPencil, faPlus, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(fas, faTrash, faPencil, faPlus, faBars);

const app = createApp(App);
app.use(store);
app.use(router);
app.component("font-awesome-icon", FontAwesomeIcon);
app.config.globalProperties.$http = axios;
app.mount('#app');